export default "__VITE_ASSET__5zna9Vsc__"